import type { NavigationGuard } from 'vue-router'
import { redirectToRegenerateToken } from '@/shared/utils/regenerate-token'
import { useToken } from '@/shared/composables/useToken'

/**
 * Navigation guard that validates the expiration of the authentication token.
 * If the token is expired, it will redirect to the login page.
 * Otherwise, it allows normal navigation.
 * @param {Object} _to - Object representing the route being navigated to.
 * @param {Object} _from - Object representing the route being navigated from.
 * @param {Function} next - Function to continue with the navigation.
 * @returns {Promise} A promise that resolves when the token expiration validation is complete.
 */
const tokenExpirationGuard: NavigationGuard = (_to, _from, next) => {
  const { isValidToken } = useToken()

  if (isValidToken.value) {
    next()
    return
  }

  redirectToRegenerateToken()
  return
}

export default tokenExpirationGuard
